import clsx from 'clsx';

export function Icon({
    icon,
    className = '',
}: {
    icon: string;
    className?: string;
}) {
    if (icon.indexOf(':') !== -1 && icon.indexOf('--') === -1) {
        throw new Error(
            `Icon names should not contain a colon (:) but only a double dash (--). Please use the format 'fa6-solid--check' instead of 'fa6-solid:check'. Offending icon: ${icon}`
        );
    }
    return <span className={clsx('iconify', icon, className)} />;
}
